import Presentation from "./presentation";

const LivePage = ( { data, isMobile } ) => {

	return (
		<Presentation
			data     = { data }
			isMobile = { isMobile }
		/>
	);
};

export default LivePage;